export const APP_PROGRESS_ACTIVATOR_ADD = 'APP_PROGRESS_ACTIVATOR_ADD';
export const APP_PROGRESS_ACTIVATOR_REMOVE = 'APP_PROGRESS_ACTIVATOR_REMOVE';

export const addActivator = id => ({ type: APP_PROGRESS_ACTIVATOR_ADD, id });
export const removeActivator = id => ({ type: APP_PROGRESS_ACTIVATOR_REMOVE, id });



// WEBPACK FOOTER //
// ./src/actions/appProgress.js